<div class="modal-big">
    <h4>Settings</h4>
    <div class="divider"></div>
    <div class="settings-block" *ngIf="model.driverTypeFilter?.outcome?.children?.length">
        <div class="block-text">
            <h6 class="subtitle-1">
                Walk scope & display settings
            </h6>
            <p class="body-2">
                Scope defines which components are included in the calculation. Only components in scope affect the variance.
            </p>
            <p class="body-2">
                Display defines which components appear as individual cards. Unselected components are grouped into the residual Balance card.
            </p>
        </div>
        <div class="block-settings">
            <div class="table-container">
                <!-- Header row -->
                <div class="row header">
                    <div class="cell">
                        <div class="subtitle-2">In Scope</div>
                    </div>
                    <div class="cell cell-long">
                        <div class="subtitle-2">Variance component</div>
                    </div>
                    <div class="cell">
                        <div class="subtitle-2">Display</div>
                    </div>
                </div>

                <!-- Data rows -->
                <div *ngIf="model.driverTypeFilter && model.driverTypeFilter.outcome" class="row" [ngClass]="{'row-primary': model.driverTypeFilter.outcome.scopeSelected}">
                    <div class="cell">
                        <label class="custom-checkbox is-check" [ngClass]="{'is-inactive': model.driverTypeFilter.outcome.disabled}">
                            <input type="checkbox" name="drvType"
                                   [checked]="model.driverTypeFilter.outcome.scopeSelected"
                                   [disabled]="model.driverTypeFilter.outcome.disabled"
                                   (click)="!model.driverTypeFilter.outcome.disabled && selectNextDriverTypeScopeVal(model.driverTypeFilter.outcome.driverTypeWithIndex.type, model.driverTypeFilter.outcome.driverTypeWithIndex.formulaComponentIndex)" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell cell-long">
                        <span class="body-2">{{ model.driverTypeFilter.outcome.driverName }}</span>
                    </div>
                    <div class="cell">
                        <label class="custom-checkbox is-check"
                               *ngIf="model.driverTypeFilter.outcome.scopeSelected">
                            <input type="checkbox"
                                   [checked]="model.driverTypeFilter.outcome.viewSelected"
                                   (click)="setNextDriverTypeFilterViewVal(model.driverTypeFilter.outcome)" />
                            <span></span>
                        </label>
                    </div>
                </div>
                <ng-container *ngIf="model.driverTypeFilter && model.driverTypeFilter.outcome && model.driverTypeFilter.outcome.children">
                    <div *ngFor="let item of model.driverTypeFilter.outcome.children" class="row" [ngClass]="{'row-primary': item.scopeSelected}">
                        <div class="cell">
                            <label class="custom-checkbox is-check" [ngClass]="{'is-inactive': item.disabled}">
                                <input type="checkbox" name="drvType"
                                       [checked]="item.scopeSelected"
                                       [disabled]="item.disabled"
                                       (click)="!item.disabled && selectNextDriverTypeScopeVal(item.driverTypeWithIndex.type, item.driverTypeWithIndex.formulaComponentIndex)" />
                                <span></span>
                            </label>
                        </div>
                        <div class="cell cell-long pl-32">
                            <span class="body-2">{{ item.driverName }}</span>
                        </div>
                        <div class="cell">
                            <label class="custom-checkbox is-check"
                                   *ngIf="item.scopeSelected || model.driverTypeFilter.outcome.scopeSelected">
                                <input type="checkbox"
                                       [checked]="item.viewSelected"
                                       (click)="setNextDriverTypeFilterViewVal(item)" />
                                <span></span>
                            </label>
                        </div>
                    </div>
                    <ng-container *ngFor="let item of model.driverTypeFilter.outcome.children">
                        <div *ngFor="let grandChild of item.children" class="row" [ngClass]="{'row-primary': grandChild.scopeSelected}">
                            <div class="cell">
                                <label class="custom-checkbox is-check" [ngClass]="{'is-inactive': grandChild.disabled}">
                                    <input type="checkbox" name="drvType"
                                           [checked]="grandChild.scopeSelected"
                                           [disabled]="grandChild.disabled"
                                           (click)="!grandChild.disabled && selectNextDriverTypeScopeVal(grandChild.driverTypeWithIndex.type, grandChild.driverTypeWithIndex.formulaComponentIndex)" />
                                    <span></span>
                                </label>
                            </div>
                            <div class="cell cell-long pl-48">
                                <span class="body-2">{{ grandChild.driverName }}</span>
                            </div>
                            <div class="cell">
                                <label class="custom-checkbox is-check"
                                       *ngIf="grandChild.scopeSelected || item.scopeSelected || model.driverTypeFilter.outcome.scopeSelected">
                                    <input type="checkbox"
                                           [checked]="grandChild.viewSelected"
                                           (click)="setNextDriverTypeFilterViewVal(grandChild)" />
                                    <span></span>
                                </label>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="settings-block">
        <div class="block-text">
            <h6 class="subtitle-1">
                Events selection
            </h6>
            <p class="body-2">
                Pick the events that are most relevant to your analysis. The Events Selection option lets you define which data points the AI should prioritize, ensuring your insights are tailored to
                the specific actions and trends you care about.
            </p>
        </div>
        <div class="block-settings">
            <span class="block-settings__title">Minimum absolute {{model.outcomeName}} impact</span>
            <div class="wrap-inputs mb-8">
                <input [value]="formatValue(model.algoSettings.minDriverValue / 20)" readonly tabindex="-1" (mousedown)="$event.preventDefault()" (click)="setMinDriverValue(model.algoSettings.minDriverValue / 20)" class="text-field" type="text">
                <input [value]="formatValue(model.algoSettings.minDriverValue / 5)" readonly tabindex="-1" (mousedown)="$event.preventDefault()" (click)="setMinDriverValue(model.algoSettings.minDriverValue / 5)" class="text-field" type="text">
                <div class="text-field__long text-field__button">
                    <input #minDriverInput [type]="minDriverFocused ? 'number' : 'text'" min="0" tabindex="-1"
                           [step]="getStep(model.algoSettings.minDriverValue)"
                           [value]="minDriverFocused ? model.algoSettings.minDriverValue : formatMinDriverValue()"
                           (input)="setMinDriverValue(+minDriverInput.value)"
                           (focus)="minDriverFocused = true" (blur)="minDriverFocused = false" class="text-field">
                    <button class="btn btn-secondary btn-small" (click)="minDriverInput.focus()">Edit</button>
                </div>
                <input [value]="formatValue(model.algoSettings.minDriverValue * 5)" readonly tabindex="-1" (mousedown)="$event.preventDefault()" (click)="setMinDriverValue(model.algoSettings.minDriverValue * 5)" class="text-field" type="text">
                <input [value]="formatValue(model.algoSettings.minDriverValue * 20)" readonly tabindex="-1" (mousedown)="$event.preventDefault()" (click)="setMinDriverValue(model.algoSettings.minDriverValue * 20)" class="text-field" type="text">
            </div>
            <p class="body-2 threshold-note mb-24" *ngIf="minDriverValueIsAuto">
                This threshold was automatically calculated and applies to the current walk only.
            </p>
            <p class="body-2 threshold-note mb-24" *ngIf="!minDriverValueIsAuto">
                This threshold was set manually, and applies to the current walk only
                (<a (click)="switchMinDriverValueToAuto()">switch back to auto</a>).
            </p>
            <span class="block-settings__title">Events selection logic</span>
            <div class="table-container">
                <!-- Header row -->
                <div class="row header">
                    <div class="cell"></div>
                    <div class="cell cell-long">
                        <div class="subtitle-2">Ranking logic</div>
                    </div>
                </div>

                <!-- Data rows -->
                <div class="row" [ngClass]="{'row-primary': model.algoSettings.selectedAlgorithm === DriverSelectionAlgorithm.Smart}">
                    <div class="cell">
                        <label class="custom-radio is-dot">
                            <input type="radio"
                                   name="selectedAlgorithm"
                                   [value]="DriverSelectionAlgorithm.Smart"
                                   [(ngModel)]="model.algoSettings.selectedAlgorithm" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell cell-long">
                        <span class="subtitle-2">AI relevance prediction</span>
                        <span class="body-2">Automatically weighs impact, granularity and trend deviations</span>
                    </div>
                </div>
                <div class="row" [ngClass]="{'row-primary': model.algoSettings.selectedAlgorithm === DriverSelectionAlgorithm.AbsDesc}">
                    <div class="cell">
                        <label class="custom-radio is-dot">
                            <input type="radio"
                                   name="selectedAlgorithm"
                                   [value]="DriverSelectionAlgorithm.AbsDesc"
                                   [(ngModel)]="model.algoSettings.selectedAlgorithm" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell cell-long">
                        <span class="subtitle-2">Largest absolute {{ model.outcomeName }} impact first</span>
                        <span class="body-2">E.g. -100, +100, +70, -70, +50, -50, ...</span>
                    </div>
                </div>
                <div class="row" [ngClass]="{'row-primary': model.algoSettings.selectedAlgorithm === DriverSelectionAlgorithm.SeqDesc}">
                    <div class="cell">
                        <label class="custom-radio is-dot">
                            <input type="radio"
                                   name="selectedAlgorithm"
                                   [value]="DriverSelectionAlgorithm.SeqDesc"
                                   [(ngModel)]="model.algoSettings.selectedAlgorithm" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell cell-long">
                        <span class="subtitle-2">Largest positive {{ model.outcomeName }} impact first</span>
                        <span class="body-2">E.g. +100, +70, +10, -10, -70, ...</span>
                    </div>
                </div>
                <div class="row" [ngClass]="{'row-primary': model.algoSettings.selectedAlgorithm === DriverSelectionAlgorithm.SeqAsc}">
                    <div class="cell">
                        <label class="custom-radio is-dot">
                            <input type="radio"
                                   name="selectedAlgorithm"
                                   [value]="DriverSelectionAlgorithm.SeqAsc"
                                   [(ngModel)]="model.algoSettings.selectedAlgorithm" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell cell-long">
                        <span class="subtitle-2">Largest negative {{ model.outcomeName }} impact first</span>
                        <span class="body-2">E.g. -100, -70, -10, +10, -+70, ...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="settings-block">
        <div class="block-text">
            <h6 class="subtitle-1">
                Aggregation
            </h6>
            <p class="body-2">
                Choose how your data is summarized and analyzed. The Aggregation Logic option allows you to define grouping rules, calculation methods, and key metrics for a clearer and more
                actionable overview.
            </p>
        </div>
        <div class="block-settings">
            <div class="table-container no-border small-cell">
                <!-- Header row -->
                <div class="row header">
                    <div class="cell cell-long">
                        <div class="subtitle-2">Component</div>
                    </div>
                    <div class="cell cell-long">
                        <div class="subtitle-2">Aggregation Logic</div>
                    </div>
                    <div class="cell cell-long">
                        <div class="subtitle-2">Weighted By</div>
                    </div>
                </div>

                <!-- Data rows -->
                <div class="row" *ngFor="let formComp of model.aggregationSettings.formComps; let i = index">
                    <div class="cell cell-long align-self-center">
                        <span class="body-2">{{ formComp.name }}</span>
                    </div>

                    <div class="cell cell-long">
                        <div class="radio-group side-by-side">
                            <label class="radio-button">
                                <input type="radio" [name]="'options' + i" [value]="UIAggregationType.sum" [(ngModel)]="formComp.aggregationMethod.type"
                                    (ngModelChange)="onAggregationMethodChange(formComp, $event)">
                                <span class="subtitle-2">Sum</span>
                            </label>
                            <label class="radio-button">
                                <input type="radio" [name]="'options' + i" [value]="UIAggregationType.averageSomehow" [(ngModel)]="formComp.aggregationMethod.type"
                                    (ngModelChange)="onAggregationMethodChange(formComp, $event)">
                                <span class="subtitle-2">Average</span>
                            </label>
                        </div>
                    </div>

                    <div class="cell cell-long">
                        <mat-form-field appearance="fill">
                            <mat-select [(value)]="formComp.aggregationMethod.columnIndex" (selectionChange)="onColumnToAvgChange(formComp.aggregationMethod)">
                                <mat-option [value]="'None'">None</mat-option>
                                <mat-option *ngFor="let column of (model.aggregationSettings.numericColumns | filterByPropNot: 'index': formComp.columnIx)" [value]="column.index">
                                    {{ column.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="divider"></div>
    <div class="mt-16">
        <button (click)="save()" class="btn btn-primary mr-16">Apply</button>
        <button (click)="reset()" class="btn btn-secondary">Reset</button>
    </div>
    <a mat-dialog-close class="btn-close material-icons-outlined">close</a>
</div>
